<template>
  <div class="url-attributes-preview">
    <div
      class="attribute"
      v-for="attribute in urlAttributes"
      :key="attribute.id"
    >
      <div class="attribute__group-name">
        {{ attribute.gmb_attribute.display_name }}
      </div>
      <div
        class="attribute__value"
        v-for="(value, index) in attribute.values"
        :key="`${value}_${index}`"
      >
        {{ value.url }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UrlAttributesPreview",
  props: {
    urlAttributes: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.url-attributes-preview {
  color: $text;

  .attribute {
    margin-bottom: $spacing * 2;

    &__group-name {
      @include font-size(16px);
      font-weight: 500;
      line-height: 20px;
      color: $primary;
      margin-bottom: $spacing;
    }

    &__value {
      font-weight: 500px;
      @include font-size(14px);

      &:not(:last-child) {
        margin-bottom: $spacing;
      }
    }
  }
}
</style>
